module.exports = __webpack_public_path__ + "assets/img/Type E (15).1bb11baa.jpg";